import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import moment from "moment";
import { TreeNode } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Check } from "src/app/shared/models/check";
import { CheckSeatItem } from "src/app/shared/models/check-seat-item.model";
import { CommandCenterReport } from "src/app/shared/models/CommandCenterReportConfiguration.item";

@Component({
	selector: "app-report-future-order-item",
	templateUrl: "./report-future-order-item.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ReportFutureOrderItemComponent implements OnInit {
	@Input() report: CommandCenterReport;
	@Output() reportChange = new EventEmitter<CommandCenterReport>();

	checkTreeData: TreeNode;
	checkSelected: Check;

	endDate: Date;

	loading: boolean = false;

	moment: any = moment;

	startDate: Date;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {}

	dateSelect() {
		if (!this.startDate || !this.endDate) {
			return;
		}
		this.loading = true;
		this.itemsByDayModel = [];
		this.getChecks(this.startDate, moment(this.endDate).add(1, "day").toDate());
	}

	async getChecks(startDate: Date, endDate: Date) {
		for (let i = 0; i < moment(endDate).diff(moment(startDate), "days"); i++) {
			try {
				const query = `start=${moment(startDate).add(i, "days").format("YYYY-MM-DD")}&end=${moment(startDate)
					.add(i, "days")
					.format("YYYY-MM-DD")}&futureOrder=1&datesearchvalue=queueDateTime`;
				const resp = await this.focuslink.checksGetByParams(this.venueService.venueKey, query);
				if (this.loading && resp.length > 0) {
					this.loading = false;
				}
				this.itemFilter(resp.map((i) => new Check(i)));
			} catch (error) {}
		}
		this.loading = false;
	}

	itemFilter(checks: Check[]) {
		checks.forEach((check) => {
			let itemDayIndex = this.itemsByDayModel.findIndex(
				(i) => moment(i.queueDate).format("YYYY-MM-DD") === moment(check.queueDateTime).format("YYYY-MM-DD")
			);
			if (itemDayIndex === -1) {
				this.itemsByDayModel.push({
					queueDate: moment(check.queueDateTime).format("YYYY-MM-DD"),
					totalCount: 0,
					totalRevenue: 0,
					items: [],
				});
				itemDayIndex = this.itemsByDayModel.length - 1;
			}
			check.seats.forEach((seat) => {
				seat.items.forEach((item) => {
					let itemRecord = this.itemsByDayModel[itemDayIndex].items.find((i) => i.menuItemKey === item.menuItemKey);
					if (!itemRecord) {
						itemRecord = {
							menuItemKey: item.menuItemKey,
							quantity: +item.quantity || 1,
							name: item.name,
							dueTimes: [`${+item.quantity || 1} @ ${moment(check.dueDateTime).format("LT")}`],
							checkItems: [item],
							itemChecks: [check],
						};
						this.itemsByDayModel[itemDayIndex].items.push(itemRecord);
					} else {
						if (itemRecord.dueTimes.includes(moment(check.dueDateTime).format("LT"))) {
							const existTimeIndex = itemRecord.dueTimes.findIndex((i) => i.includes(moment(check.dueDateTime).format("LT")));
							let quantity = +itemRecord.dueTimes[existTimeIndex].split(" @ ")[0];
							quantity += +item.quantity;
							itemRecord.dueTimes[existTimeIndex] = `${quantity} @ ${itemRecord.dueTimes[existTimeIndex].split(" @ ")[1]}`;
						} else {
							itemRecord.dueTimes.push(`${+item.quantity || 1} @ ${moment(check.dueDateTime).format("LT")}`);
						}

						itemRecord.quantity += +item.quantity || 1;
						itemRecord.checkItems.push(item);
						itemRecord.itemChecks.push(check);
					}
					this.itemsByDayModel[itemDayIndex].totalCount += +item.quantity || 1;
					this.itemsByDayModel[itemDayIndex].totalRevenue += +item.price * (+item.quantity || 1);
				});
			});
		});
	}

	itemsByDayModel: {
		queueDate: string;
		totalCount: number;
		totalRevenue: number;
		expanded?: boolean;
		items: {
			quantity: number;
			name: string;
			menuItemKey: number;
			dueTimes: string[];
			itemChecks: Check[];
			checkItems: CheckSeatItem[];
		}[];
	}[];

	treeNode: TreeNode = {};
}
